import { Pipe, PipeTransform } from '@angular/core';
import { createTILinks } from './ti-links.functions';

@Pipe({
  name: 'renderTiLinks'
})
export class RenderTiLinksPipe implements PipeTransform {
    transform(text?: string, activityType: string = ''): string {
        return createTILinks(text, activityType);
    }
};